import React from "react";
import PropTypes from "prop-types";
import LinkedIn from "rialto-icons/Linkedin";

import styles from "./LinkedInAuthButton.css";

const LinkedInAuthButton = ({ text, url }) => (
  <a className={styles.root} href={url}>
    <LinkedIn dimensions={{ height: "1.4rem", width: "1.4rem" }} />
    {text}
  </a>
);

LinkedInAuthButton.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default LinkedInAuthButton;
